/*react*/
import React, {Component, useEffect, useState} from 'react';
import connect from "react-redux/es/connect/connect";
import {Link} from 'react-router-dom';
import withRouter from 'react-router/es/withRouter';

/*translate*/
import {translate} from "react-i18next";

/*assets*/
import styles from './styles.scss';
import stylesMobile from './stylesMobile.scss';
import logo from '../../../assets/media/blsck.svg';
import menu from '../../../assets/media/forum/menu.svg';
import menu_blue from '../../../assets/media/forum/menu_blue.svg';
import close from '../../../assets/media/forum/close.svg';
import close_blue from '../../../assets/media/forum/close_blue.svg';

/*utils@_@*/
import {views} from '../../../constants/views';
import {isMobile} from "react-device-detect";
import classnames from 'classnames';
import {API_URL} from '../../../constants/mainApi';

/*components*/
import {Localizator} from "../../utils/localizator";
import {UserCard} from "./userCard";
import {Social} from '../forumFooter';

const DropDownList = (props) => {
    const { 
        close = f => f, 
        title = '', 
        items = [], 
        root = '/', 
        selected = false, 
        background = '#E8F1FB', 
        tab = '' } = props;
    const [state, setState] = useState({open: false, /*showPanel: null,*/ hovering: null, });
    //console.log('TAB IS', tab);
    return (
        <div className={styles.gambItem}>
            <hr className={styles.gambSeparator}/>
            <Link to={root}
                className={classnames(styles.gambItemTitle, selected ? styles.gambItemTitleSelected : '', 
                    items.length > 0 ? (state.open ? styles.gambItemOpen : styles.gambItemClose) : '')}>
                {title}
                <div 
                    onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        if (items.length > 0) setState(state => ({...state, open: !state.open}));
                    }}
                    className={styles.hitBox}></div>
            </Link>
            {state.open && 
                <div className={styles.gambItemLocations}>
                    {items.map((e, idx) => 
                        <Link to={(root != '/' && e.tab && e.tab.length > 0) ? `${root}/${e.tab}` : '#'}
                            onClick={close}
                            style={{
                                backgroundColor: typeof state.hovering == 'number' ?
                                    state.hovering == idx ? 
                                        (e.background || background) : 
                                        'white' :
                                    /*state.showPanel == idx*/ tab == e.tab?
                                        (e.background || background) :
                                        'white'
                            }}
                            onMouseOver={() => setState(state => ({...state, hovering: idx}))}
                            onMouseOut={() => setState(state => ({...state, hovering: null}))}
                            className={styles.gambItemLocation}>
                            <div className={styles.gambItemLogoWrapper}>
                                <img src={((/*state.showPanel == idx*/ tab == e.tab || state.hovering == idx) && e.logoHover) ? e.logoHover : e.logo} 
                                    alt='logo'/>
                            </div>
                            <div className={classnames(styles.gambLocationItemTitle,
                                (/*state.showPanel == idx*/ tab == e.tab || state.hovering == idx) ? styles.gambLocationItemTitleBold : '' )}>
                                {e.title}
                            </div>
                        </Link>
                    )}
                </div>
            }
            {props.bottomSeparator && <hr className={styles.gambSeparator}/>}
        </div>
    )
}

export class HeaderUI extends Component {
    constructor(props) {
        super(props);
        this.menuRef = React.createRef();
        this.state = {
            menu: false, 
        };
    }

    render() {
        const {page, tab, isAuthorized, userStatus} = this.props;
        return <div className={isMobile ? stylesMobile.header : styles.header}>
            <div className={styles.headerBack}>
                <div className={styles.headerContent}>
                    <div className={styles.headerContentPart}>
                        <Link to={isAuthorized ? userStatus === "admin" ? '/homeinvienna_boosterspro_eto_vse_luna' : '/championships' : '/'} className={styles.headerTitle}>
                         <img src={logo} alt='logo' className={styles.logoImg}/>       
                        </Link>
                        <div className={styles.headerNavigate}>
                            <Link to='/championships' className={styles.headerNavigateButton}>
                                {this.props.t("header.champs")}
                                {page === views.CHAMPIONSHIPS_PAGE ? <div className={styles.pageIndicatorActive}/>
                                    : <div className={styles.pageIndicator}/>}
                            </Link>
                            <Link to='/rating' className={styles.headerNavigateButton}>
                                {this.props.t("header.rating")}
                                {page === views.RATING_PAGE ? <div className={styles.pageIndicatorActive}/>
                                    : <div className={styles.pageIndicator}/>}
                            </Link>
                            <Link to='/forum' className={styles.headerNavigateButton}>
                                {this.props.t("header.forum")}
                                {page === views.FORUM_PAGE ? <div className={styles.pageIndicatorActive}/>
                                    : <div className={styles.pageIndicator}/>}
                            </Link>
                            {userStatus === "admin" &&
                            <Link to='/vacancy' className={styles.headerNavigateButton}>
                                {this.props.t("header.vacancy")}
                                {page === views.VACANCY_PAGE ? <div className={styles.pageIndicatorActive}/>
                                    : <div className={styles.pageIndicator}/>}
                            </Link>}
                            <Link to='/about' className={styles.headerNavigateButton}>
                                {this.props.t("header.about")}
                                {page === views.ABOUT_PAGE ? <div className={styles.pageIndicatorActive}/>
                                    : <div className={styles.pageIndicator}/>}
                            </Link>
                        </div>
                    </div>
                    <div className={styles.headerContentPart}>
                        <div className={styles.registrationNavigate}>
                            <Localizator/>
                            {!isAuthorized ?
                                <Link to='/login' className={styles.registrationNavigateButton}>
                                    {this.props.t("header.login")}
                                    {page === views.LOGIN_PAGE ? <div className={styles.pageIndicatorActive}/>
                                        : <div className={styles.pageIndicator}/>}
                                </Link> :
                                <UserCard/>}
                            {/*isMobile*/ true && 
                                <div 
                                    onClick={() => this.setState(state => ({menu: !state.menu}), () => this.menuRef.current && (
                                        this.menuRef.current.src = this.state.menu ? close_blue : menu_blue
                                    ))}
                                    className={classnames(styles.gambMenuImg, this.state.menu ? styles.closeMenu : styles.openMenu)}></div> 
                            }
                                {/*<img 
                                onClick={() => this.setState(state => ({menu: !state.menu}), () => this.menuRef.current && (
                                    this.menuRef.current.src = this.state.menu ? close_blue : menu_blue
                                ))}
                                onMouseOut={() => this.menuRef.current && (this.state.menu ? 
                                    (this.menuRef.current.src = close) :
                                    (this.menuRef.current.src = menu))}
                                onMouseOver={() => this.menuRef.current && (this.state.menu ? 
                                    (this.menuRef.current.src = close_blue) :
                                    (this.menuRef.current.src = menu_blue))}
                                className={styles.gambMenuImg} 
                                src={this.state.menu ? close : menu} alt='menu' ref={this.menuRef}/>*/}
                        </div>
                    </div>
                    {page === views.MAIN_PAGE && <div className={styles.separator}/>}
                </div>
                {page !== views.MAIN_PAGE && <div className={styles.separator}/>}
            </div>
            {this.state.menu && 
                <div className={styles.gambMenuWrapper} onClick={() => this.setState({menu: false})}>
                    <div className={styles.gambMenu} onClick={e => e.stopPropagation()}>
                        {!isAuthorized ? 
                            <Link to='/login' className={styles.gambMenuLogin}>
                                {this.props.t("header.login")}
                            </Link> :
                            <div className={styles.gambMenuUserLine}>
                                <Link to={`/user/${this.props.user.login}`} className={styles.gambMenuUserCard}>
                                    <img /*src={this.props.user.avatarAfterSave != null ? this.props.user.avatarAfterSave : this.props.user.avatar}*/
                                         src={`${API_URL}us/av/vsevolod20009882.jpg`}
                                         alt='avatar'/>
                                    <div>
                                        {this.props.user.nickname && this.props.user.nickname.length > 0 ? this.props.user.nickname :this.props.user.login}
                                    </div>
                                </Link> 
                            </div>
                        }
                        <DropDownList
                            close={() => this.setState({menu: false})}
                            tab={tab}
                            selected={page === views.CHAMPIONSHIPS_PAGE}
                            root='/championships'
                            items={[
                                {
                                    logo: require('../../../assets/media/icons/all-card_grey_big.png'),
                                    logoHover: require('../../../assets/media/icons/all-card_color_big.png'),
                                    title: this.props.t('tabs.type_champs.all'),
                                    tab: 'all',
                                },
                                {
                                    logo: require('../../../assets/media/icons/fire_grey_big.png'), 
                                    logoHover: require('../../../assets/media/icons/fire_color_big.png'), 
                                    title: this.props.t('tabs.type_champs.active'), 
                                    background: '#FBE9EA', 
                                    tab: 'active', 
                                }, 
                                {
                                    logo: require('../../../assets/media/icons/infinity_grey_big.png'), 
                                    logoHover: require('../../../assets/media/icons/infinity_color_big.png'), 
                                    title: this.props.t('tabs.type_champs.infinity'), 
                                    tab: 'infinite', 
                                }, 
                                {
                                    logo: require('../../../assets/media/icons/hourglass-ended_grey_big.png'), 
                                    logoHover: require('../../../assets/media/icons/hourglass-ended_color_big.png'), 
                                    title: this.props.t('tabs.type_champs.ended'), 
                                    tab: 'ended', 
                                }, 
                            ]}
                            title={this.props.t('header.champs')}/>
                        <DropDownList
                            close={() => this.setState({menu: false})}
                            tab={tab}
                            selected={page === views.RATING_PAGE}
                            root='/rating'
                            items={[
                                {
                                    logo: require('../../../assets/media/forum/dot.svg'),
                                    logoHover: require('../../../assets/media/forum/dot_blue.svg'),
                                    title: this.props.t('tabs.rating.rating'),
                                    tab: 'general', 
                                },
                                {
                                    logo: require('../../../assets/media/forum/dot.svg'),
                                    logoHover: require('../../../assets/media/forum/dot_blue.svg'),
                                    title: this.props.t('tabs.rating.formula'),
                                    tab: 'formula', 
                                },
                                {
                                    logo: require('../../../assets/media/forum/dot.svg'),
                                    logoHover: require('../../../assets/media/forum/dot_blue.svg'),
                                    title: this.props.t('tabs.rating.medals'),
                                    tab: 'medals', 
                                },
                            ]}
                            title={this.props.t('header.rating')}/>
                        <DropDownList
                            close={() => this.setState({menu: false})}
                            tab={tab}
                            selected={page === views.FORUM_PAGE}
                            root='/forum'
                            items={[
                                {
                                    logo: require('../../../assets/media/forum/lenta.svg'),
                                    logoHover: require('../../../assets/media/forum/lenta_blue.svg'),
                                    title: this.props.t('forum.boosters_lenta'),
                                    tab: 'lenta', 
                                },
                                {
                                    logo: require('../../../assets/media/forum/list.svg'),
                                    logoHover: require('../../../assets/media/forum/list_blue.svg'),
                                    title: this.props.t('forum.all_threads'),
                                    tab: 'threads', 
                                },
                                {
                                    logo: require('../../../assets/media/forum/champ.svg'),
                                    logoHover: require('../../../assets/media/forum/champ_blue.svg'),
                                    title: this.props.t('forum.champ_threads'),
                                    tab: 'champ_threads', 
                                },
                                {
                                    logo: require('../../../assets/media/forum/bookmarks.svg'),
                                    logoHover: require('../../../assets/media/forum/bookmarks_blue.svg'),
                                    title: this.props.t('forum.bookmarks'),
                                    tab: 'bookmarks', 
                                },
                                {
                                    logo: require('../../../assets/media/forum/subscriptions.svg'),
                                    logoHover: require('../../../assets/media/forum/subscriptions_blue.svg'),
                                    title: this.props.t('forum.subscriptions'),
                                    tab: 'subscriptions', 
                                },
                            ]}
                            title={this.props.t('header.forum')}/>
                        <DropDownList
                            close={() => this.setState({menu: false})}
                            selected={page === views.ABOUT_PAGE}
                            root='/about'
                            bottomSeparator
                            title={this.props.t('header.about')}/>
                        <div className={styles.panelFooter}>
                            <a href={'/file.pdf'} className={styles.agreement} download={"Пользовательское соглашение Boosters.pro.pdf"}>
                                {this.props.t("buttons.agreement")}
                            </a>
                            <Social/>
                        </div>
                    </div>
                </div>
            }
        </div>
    }
}


export const Header = translate()(withRouter(connect(
    store => ({
        activeLanguage: store.persistStore.language.activeLanguage,
        isAuthorized: store.persistStore.isAuthorized,
        user: store.user, 
        userStatus: store.user.role,
    }),
)(HeaderUI)));





// WEBPACK FOOTER //
// src/components/forumFullPage/forumHeader/index.jsx